import { render, staticRenderFns } from "./NewsTutorialList.vue?vue&type=template&id=d3a6e64c&scoped=true"
import script from "./NewsTutorialList.vue?vue&type=script&lang=js"
export * from "./NewsTutorialList.vue?vue&type=script&lang=js"
import style0 from "./NewsTutorialList.vue?vue&type=style&index=0&id=d3a6e64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a6e64c",
  null
  
)

export default component.exports